import { localStorageItemKeys } from 'src/constants/local-storage-items'

export function removeLocalStorageItems() {
  Object.keys(localStorage).forEach((key) => {
    if (!Object.values(localStorageItemKeys.retainedPostLogout).includes(key)) {
      localStorage.removeItem(key)
    }
  })
}
